module.exports = __webpack_public_path__ + "static/media/Team1.c5d2d8d9.jpg";